'use strict';

angular.module('atex.dam').controller('DamVersionsController', [
      '$scope', '$rootScope', '$state', '$stateParams',
      '$filter', '$sce', '$timeout', '$q',
      'ContentService', 'DamService', 'DamNotificationService', 'DamCompareModal',
      'DamTemplateService', 'configuration', '$modal', '$translate',
function($scope, $rootScope, $state, $stateParams,
         $filter, $sce, $timeout, $q,
         ContentService, DamService, DamNotificationService, DamCompareModal,
         DamTemplateService, configuration, $modal, $translate) {
  
  var currentLineHeightThumbList = 120;
  $scope.entries  = [];
  $scope.selected  = [];
  $scope.querying = true;

  $scope.id = $stateParams.id; 
  
  $scope.modified = undefined;
  $scope.compareConfig = undefined;
  $scope.usePrintServer = false;

  $scope.back = function() {
    if ($scope.modified) {
      // Notify the list
      $timeout(function() {
        $rootScope.$broadcast('dam:updatedItem', $scope.modified);
      });
    }
    $state.go('list');
  };

  $scope.clearSelection = function() {
    $scope.selected.length = 0;
  };

  function findUserById(users, userId) {
    var user = _.find(users, function(obj) {
      return obj.principalId === userId;
    });
    return user;
  }

  function updateChannelContentData(deskAspects, printVariantsAspect) {
    if (!deskAspects || !printVariantsAspect) {
      return;
    }
    var channelContentDataAspectElements = atex.onecms.ObjectUtils.getByPath(deskAspects, 'atex.ChannelContentData/data/channels/Print/elements');
    if (!channelContentDataAspectElements) {
      return;
    }
    printVariantsAspect.data.attributes.forEach(function(attribute) {
      if (attribute.channel === 'Print') {
        // Find the equivalent in the channelContentDataAspect
        channelContentDataAspectElements.forEach(function(element) {
          if (element.elementName === attribute.element) {
            element.content = attribute.content;
          }
        });
      }
    });
  }

  function updatePrintVariantAspect(deskAspects) {
    if (!deskAspects) {
      return;
    }
    var printVariantsAspectAttributes = atex.onecms.ObjectUtils.getByPath(deskAspects, 'atex.PrintVariants/data/attributes');
    if (!printVariantsAspectAttributes) {
      return;
    }

    var channelContentDataAspectElements = atex.onecms.ObjectUtils.getByPath(deskAspects, 'atex.ChannelContentData/data/channels/Print/elements');
    if (!channelContentDataAspectElements) {
      return;
    }
    printVariantsAspectAttributes.forEach(function(attribute) {
      if (attribute.channel === 'Print') {
        // Find the equivalent in the channelContentDataAspect
        channelContentDataAspectElements.forEach(function(element) {
          if (element.elementName === attribute.element) {
             attribute.content = element.content;
          }
        });
      }
    });
  }

  var collectVersions = function(versions) {
    $scope.querying = true;
    var versionsPromises = versions.map(function(item, index) {
      return ContentService.getContent({ id: item.version }).then(function(responseInfo) {
        atex.dam.AngularUtils.fixUrls(responseInfo.data);
        // attach to the item a temp versionInfo
        responseInfo.versionInfo = item;
        DamService.getUsers().then(function(users) {
          var user = findUserById(users, item.creatorId);
          responseInfo.versionInfo.creatorName = (user && user.name) ? user.name : item.creatorId;
        });
        if (index === (versions.length - 1) && hasPrintContent(responseInfo.data)) {
          // The last in the list is at this moment the latest version, for the latest version retrieve the print
          // content directly from the print system and update atex.PrintVariants and atex.ChannelContentData
          return DamService.getActualPrintContent(responseInfo.id).then(function (resp) {
            var printVariants = atex.onecms.ObjectUtils.getByPath(resp, 'data/atex.PrintVariants');
            if (printVariants) {
              updateChannelContentData(responseInfo.data.aspects, printVariants);
              responseInfo.data.aspects['atex.PrintVariants'] = printVariants;
            }
            return responseInfo;
          }).then(null, function(error) {
            console.log('getActualPrintContent returns', error);
            return responseInfo;
          });
        } else {
          // For old versions align atexPrintVariants with atex.ChannelContentData values
          updatePrintVariantAspect(responseInfo.data.aspects);
          return responseInfo;
        }
      }).then(null, function(error) {
        if (!error.rootCause || error.rootCause.status!==403) {
          console.log('ERROR: Getting content:', error);
        }
        return undefined;
      });
    });
    return $q.all(versionsPromises).then(function(results) {
      return results;
    });
  };

  var loadContentHistory = function(id) {
    $scope.entries = [];
    $scope.selected  = [];
    ContentService.getContentHistory({id : $scope.id}).then(function (responseData) {
      collectVersions(responseData.data.versions).then(function(list) {
        list = _.filter(list, function(_entry) {
          return (typeof _entry !== "undefined");
        });
        list.reverse().forEach(function(entry, index) {
          if (typeof entry !== 'undefined') {
            if (index === 0) {
              // Mark the first in the entries list as current
              entry.versionInfo.current = true;
            }
            entry._data = entry.data;
            delete entry.data;
          }
        });
        $scope.entries = list;
        $scope.selected  = [];
        $scope.selected.push($scope.entries[0]);
        $scope.querying = false;

        loadCompareConfig( $scope.id, $scope.entries[0] );
      }).then(null, function(error) {
        console.log('Error while loading versions list!', error);
        $scope.querying = false;
      });
    }, function (error) {
      console.log('ERROR: getContentHistory error:', error);
      $scope.querying = false;
    });
  };

  loadContentHistory($scope.id);

  var loadCompareConfig = function( contentId, entry ) {
    var templateId = entry._data.aspects.contentData.data._type;
    templateId += ".dam.preview";
    var inputTemplate = entry._data.aspects.contentData.data.inputTemplate;
    DamTemplateService.getTemplateByIdAndInputTemplate(templateId, inputTemplate).then(function(template){
      $scope.onecmsTemplate = template;

      var compare = _.extend( {binding: "channels", usePrintServer: false}, template.compare);

      $scope.usePrintServer = compare.usePrintServer;

      $scope.compareConfig = _.find(template.dataBindings, function(binding) {
        return binding.name === compare.binding;
      });
    }).then(null, function(error) {
      //$scope.showSpinner = false;
      console.log('ERROR: loadVersion:', error);
    });
  };

  $scope.promptForMakeCurrent = function() {
    $translate(['_ASK_PROCEED_RESTORE_VERS_', '_CANCEL_BUTTON_', '_OK_BUTTON_',
      '__RESTORE_ONLY_WEB__', '__RESTORE_ONLY_PRINT__', '__RESTORE_ALL_CHANNELS__']).then(function (translations) {
      // Show Modal
      var modalScope = $scope.$new(true);
      modalScope.data = {
        options: [{
          value: 'web',
          label: translations.__RESTORE_ONLY_WEB__
        }],
        value: 'web'  // Default is to restore only web content
      };
      if (hasPrintContent($scope.selected[0]._data)) {
        modalScope.data.options.push({
          value: 'print',
          label: translations.__RESTORE_ONLY_PRINT__
        });
        modalScope.data.options.push({
          value: 'all',
          label: translations.__RESTORE_ALL_CHANNELS__
        });
      }

      modalScope.panelTitle = translations._ASK_PROCEED_RESTORE_VERS_;
      modalScope.submitLabel = translations._OK_BUTTON_;
      modalScope.cancelLabel = translations._CANCEL_BUTTON_;
      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-radios-modal.html',
        modalClass: 'dam-radios-modal confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });
      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            modalEl.remove();
          });
          modalEl.modal('hide');
        });
      };
      modalScope.doCancel = function () {
        destroyModal();
      };
      modalScope.doSubmit = function () {
        modalScope.sending = true;
        $scope.makeCurrent(modalScope.data.value).then(function() {
          destroyModal();
        }).finally(function() {
          modalScope.sending = false;
        });
      };

    });
  };

  $scope.canMakeCurrent = function() {
    if ($scope.selected.length===1 && !angular.equals($scope.selected[0], $scope.entries[0])) {
      return true;
    }
    return false;
  };

  function hasPrintContent(articleData) {
    var printVariantsAttributes = atex.onecms.ObjectUtils.getByPath(articleData, 'aspects/atex.PrintVariants/data/attributes');
    if (!printVariantsAttributes) {
      return false;
    }
    // Try to find at least one Print element with id > 0
    return _.find(printVariantsAttributes, function (attr) {
      return attr.channel === 'Print' && attr.id > 0;
    });
  }

  function copyAspect(from, to, aspectName) {
    var src = atex.onecms.ObjectUtils.getByPath(from, '_data/aspects/' + aspectName);
    var dst = atex.onecms.ObjectUtils.getByPath(to, '_data/aspects/' + aspectName);
    if (src && !dst) {
      to['_data']['aspects'][aspectName] = angular.copy(src);
    } else if (!src && dst) {
      delete to['_data']['aspects'][aspectName];
    } else if (src && dst) {
      to['_data']['aspects'][aspectName]['data'] = src['data'];
    }
  }

  function copyExtraAspects(from, to) {
    ['engagementAspect', 'atex.dam.standard.Publevents'].forEach(
      function(aspectName) {
        copyAspect(from, to, aspectName);
      }
    );
  }

  function copyPrintAspects(from, to) {
    ['atex.ChannelContentData', 'atex.PrintVariants', 'atex.WFContentStatus',
      'hermesElements', 'atex.ReconcileAttributes'].forEach(
      function(aspectName) {
        copyAspect(from, to, aspectName);
      }
    );
  }

  $scope.makeCurrent = function(type) {
    console.log(type);
    if ($scope.canMakeCurrent()) {
      if (type === 'web') {
        var toRestore = angular.copy($scope.selected[0]);
        toRestore.revision = $scope.entries[0].revision;
        // Always keep latest engagements and publication events
        copyExtraAspects($scope.entries[0], toRestore);
        // If restoring only WEB Content, keep current version (latest) print aspects
        copyPrintAspects($scope.entries[0], toRestore);
        atex.dam.AngularUtils.sanitizeContentData(toRestore._data.aspects.contentData);
        delete(toRestore._data.lockData);
        return ContentService.updateContent({
          id: toRestore.id,
          revision: toRestore.revision,
          data: toRestore._data
        }).then(function(response) {
          $scope.modified = toRestore;
          loadContentHistory($scope.id);
        }).then(null, function(error) {
          $scope.saving = false;
          var message = error.cause || 'Error restoring version';
          DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
          throw error;
        });
      } else if (type === 'print' || type === 'all') {
        return DamService.restorePrintContent($scope.selected[0].versionInfo.version, null, type === 'all').then(function (resp) {
          console.log('restorePrintContent returns', resp);
          setTimeout(function () {
            loadContentHistory($scope.id);
          }, 100);
        }).then(null, function(error) {
          $scope.saving = false;
          var message = error.cause || 'Error restoring version';
          DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
          throw error;
        });
      }
    }
    return $q.when();
  };

  $scope.canCompare = function() {
    if ($scope.compareConfig && $scope.selected.length>0) {
      return true;
    }

    return false;
  };

  $scope.showJson = function() {
    ContentService.getContent({ id: $scope.selected[0].versionInfo.version}).then(function(responseInfo) {
      if ($scope.selected.length === 1) {
        var library = {};

        library.json = {
          prettyPrint: function(obj) {
            var prettyPrintString = function(s) {
              return s.replace(/&/g, '&amp;')
                .replace(/\\"/g, '&quot;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            };
            var deepPrettyPrint = function(obj, spaces, indent) {
              var idx;
              var value;
              var str = '';
              if (_.isArray(obj)) {
                str += '<span class=json-value>[';
                if (obj.length > 0) {
                  str += '\n';
                  for (idx = 0; idx < obj.length; idx++) {
                    value = obj[idx];
                    str += ' '.repeat(spaces + indent) + deepPrettyPrint(value, spaces + indent, indent);
                    if (idx < obj.length - 1) {
                      str += ',';
                    }
                    str += '\n';
                  }
                  str += ' '.repeat(spaces);
                }
                str += ']</span>';
              } else if (_.isObject(obj)) {
                str += '{';
                var keys = Object.keys(obj);
                if (keys.length > 0) {
                  str += '\n';
                  for (idx = 0; idx < keys.length; idx++) {
                    var key = keys[idx];
                    str += ' '.repeat(spaces + indent) + '<span class=json-key>"' + key + '"</span>: ';
                    value = obj[key];
                    str += deepPrettyPrint(value, spaces + indent, indent);
                    if (idx < keys.length - 1) {
                      str += ',';
                    }
                    str += '\n';
                  }
                  str += ' '.repeat(spaces);
                }
                str += '}';
              } else if (typeof obj === 'string' || obj instanceof String) {
                str += '<span class=json-string>' + prettyPrintString(JSON.stringify(obj)) + '</span>';
              } else {
                str += '<span class=json-value>' + JSON.stringify(obj) + '</span>';
              }
              return str;
            };
            return deepPrettyPrint(obj, 0, 2);
          }
        };
        var x = window.open();
        x.document.open();
        x.document.write('<style>pre {height: auto;max-height: 1800px;overflow: auto;background-color: #eeeeee;word-break: normal !important;word-wrap: normal !important;white-space: pre !important;}');
        x.document.write('.json-key {color: brown;}.json-value {color: navy;}.json-string {color: olive;}</style>');
        x.document.write('<html><body><pre>' + library.json.prettyPrint(removeTypeProp(responseInfo.data)) + '</pre></body></html>');
        x.document.close();
      }else if ($scope.selected.length === 2){
        ContentService.getContent({ id: $scope.selected[1].versionInfo.version}).then(function(responseInfo2) {
          compareJson(removeTypeProp(responseInfo.data.aspects),removeTypeProp(responseInfo2.data.aspects));
        });
      }else if($scope.selected.length > 2){
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: "Max 2 items"}), true);
      }
    });
  };

  function removeTypeProp(obj) {
    for (var property in obj) {
      if (typeof obj[property] === "object" && !(property.endsWith("_type") || property.endsWith("_types"))) {
        delete obj.property;
        var newJsonData= removeTypeProp(obj[property]);
        obj[property]= newJsonData;
      } else {
        if ((property.endsWith("_type") || property.endsWith("_types"))) {
          delete obj[property];
        }
      }
    }
    return obj;
  }

  var compareJson = function(leftRev, rightRev) {
    if (configuration.getJsonAspectsToCompare()){
      Object.keys(leftRev).forEach(function(aspect){
        if (!configuration.getJsonAspectsToCompare().includes(aspect)){
          delete leftRev[aspect];
        }
      });
      Object.keys(rightRev).forEach(function(aspect){
        if (!configuration.getJsonAspectsToCompare().includes(aspect)){
          delete rightRev[aspect];
        }
      });
    }
    $rootScope.leftRev = leftRev;
    $rootScope.rightRev = rightRev;
    $rootScope.idSelectedVersion = $scope.selected[0].id;
    $state.go('list.jsoncompare');
  };

  $scope.compare = function() {
    if ($scope.canCompare()) {
      if ($scope.selected.length === 1){
        if ($scope.entries[0] !== $scope.selected[0]){
          $scope.selected.push($scope.entries[0]);
        }else{
          $scope.selected.push($scope.entries[1]);
        }
      }
      var onMakeCurrent = function( update, item, message ) {
        if ( update ) {
          $scope.modified = item;
          loadContentHistory($scope.id);
        }

        if ( !update && message && message !== '' ) {
          $scope.saving = false;
          DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
        }
      };

      var compareOptions = {
        entries:  $scope.entries,
        selected:  $scope.selected,
        contentId: $scope.id,
        compareBinding: $scope.compareConfig,
        usePrintServer: $scope.usePrintServer,

        onMakeCurrent: onMakeCurrent
      };

      var compareModal = DamCompareModal.showCompare( compareOptions );
    }

  };



}]);

